export default "__VITE_ASSET__CTBayygM__"